import React, { useEffect, useState } from "react";

// styles
import * as Styled from './styles';
import * as sharedStyled from '../styles';
// libs
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Form({ typeOptions, handleSubmit }) {
    const [ userString, setUserString ] = useState('')
    const [ types, setTypes ] = useState([])
    const [ typesUsed, setTypesUsed ] = useState( typeOptions )
    const [ sources, setSources ] = useState([])
    const [ dateInterval, setDateInterval ] = useState({
        min: '',
        max: ''
    })

    const sourceOptions = [
        {value: 'S', label: 'Scrum.org'},
        {value: 'AA', label: 'AgileAlliance.com'},
        {value: 'AC', label: 'AgileConnection.com'},
        {value: 'SA', label: 'ScrumAlliance.org'}
    ]

    useEffect(() => {
        setTypesUsed(typeOptions)
    }, [typeOptions]) 

    function handleFormSubmit(e) {
        e.preventDefault()
        handleSubmit(types, sources, userString, dateInterval)
    }

    function handleUserStringChange(e) {
        setUserString(e.target.value)
    }

    function handleTypesChange(options) {
        setTypes(options.map(x => {
                return x.value
            })
        )
    }

    function handleSourcesChange(options) {
        const newSources = options.map(x => {
            return x.value
        })

        setSources(newSources)
    
        if ( newSources.length > 0 ) {
            setTypesUsed(
                typeOptions.filter(x => newSources.includes(x.source))
            )
        } else {
            setTypesUsed( typeOptions )
        }
    }

    function handleDateChange(date, name) {
        setDateInterval(prev => {
            return {
                ...prev,
                [name]: date
            }
        })
    }

    const customStyles = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        control: ( base ) => ({
          ...base,
          minHeight: '34px',
          maxHeight: '4.5rem',
          overflowY: 'scroll'
        }),
    };

    return (
        <Styled.Form onSubmit={handleFormSubmit}>
            <h3>Search</h3>
            <hr></hr>

            <label htmlFor="user_string">Search string:</label>
            <Styled.InputField 
                placeholder='("Search" or "Grey") and "Results"'
                onChange={handleUserStringChange} 
                id="user_string" 
                value={ userString }
            >
            </Styled.InputField>

            <br/>

            <label htmlFor="dateMin">Date interval:</label>
            <br></br>
            <Styled.DatePickerStyle>
                <DatePicker
                    wrapperClassName="date-picker"
                    dateFormat="dd/MM/yyyy"
                    onChange={ (date) => handleDateChange(date, 'min') }
                    selected={ dateInterval.min }
                />
            </Styled.DatePickerStyle>
            <label>to</label>
            <Styled.DatePickerStyle>
                <DatePicker
                    dateFormat="dd/MM/yyyy"
                    onChange={ (date) => handleDateChange(date, 'max') }
                    selected={ dateInterval.max }
                />
            </Styled.DatePickerStyle>

            <br/><br/>

            <Styled.Line>
                <Styled.SelectorContainer>
                    <label htmlFor="sources">Select sources</label>
                    <Select
                        onChange={handleSourcesChange}
                        isMulti
                        maxMenuHeight="200px"
                        name="sources"
                        options={sourceOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={ document.body } 
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </Styled.SelectorContainer>

                <Styled.SelectorContainer style={{'float': 'right'}}>
                    <label htmlFor="types">Select types</label>
                    <Select
                        onChange={handleTypesChange}
                        isMulti
                        maxMenuHeight="200px"
                        name="types"
                        options={ typesUsed }
                        className="basic-multi-select"
                        classNamePrefix="select"
                        noOptionsMessage={() => "Loading..."}
                        menuPortalTarget={ document.body } 
                        styles={ customStyles }
                        
                    />
                </Styled.SelectorContainer>
            </Styled.Line>

            <br/>
            
            <Styled.ButtonContainer>
                <sharedStyled.DownloadButton type="submit">
                    Search
                </sharedStyled.DownloadButton>
            </Styled.ButtonContainer>
        </Styled.Form>
    );
}

export default Form;
